export const locale = {
    lang: 'es',
    data: {
      'CIERRE': {
        'LABEL1': 'Encuesta en progreso.',
        'LABEL2': 'Ver avance.',
        'LABEL3': 'Encuesta completa.',
        'LABEL4': 'Ver resultados.',
        'BTN_CIERRE': 'Cerrar ahora.',
        'ALERT':{
          'MESSAGE': '¿Confirme realizar el cierre anticipado de la encuesta?',
          'BTN_CONFIRM': 'Sí',
          'BTN_CANCEL': 'No'
        },
        'LINK': 'Ingrese al siguiente enlace para visualizar el progreso actual de la encuesta:',
        'ACTIONS':{
          'TITULO': 'Acciones.',
          'WANNADO': '¿Qué desea realizar?'
        },
        'COMPLETO':{
          'TAG': 'La encuesta ha concluído correctamente.',
          'CARDTIT': 'Consulta de resultados.',
          'LINK': 'Ingrese al siguiente enlace para visualizar los resultados obtenidos en la encuesta:'
        }
      },

      'ALERTS':{
        'OK':'OK'
      },
      'CERTIFICAR': {
        'IDIOMAS': {
          'ELEGIR': 'Elegir',
          'STATUS': {
            'PEND': 'Completar paso',
            'DONE': 'Paso completado'
          },
          'MENSAJES':{
            'ADDLANG': 'Se añadió el idioma ',
            'NOADITIONAL': 'Se eligió la opción sin idiomas adicionales.',
            'ERRORADD': 'Ocurrió un error al añadir el idioma.',
            'LANGDEL': 'Se eliminó el idioma ',
            'NOADITIONALDEL': 'Se canceló la selección sin idiomas adicionales.',
            'ERRORDEL': 'Ocurrió un error al eliminar el idioma.',
            'MAINPICKED': 'Usted ha elegido el idioma nativo para la encuesta.<br><br>Para cambiarlo, quite el idioma seleccionado y elija el nuevo idioma.'
          },
          'CARD1': {
            'TITULO': 'Idioma principal.',
            'ACCION': {
              'PRE': 'No ha seleccionado el idioma principal.',
              'POST': 'Ha seleccionado el idioma:'
            },
            'MODAL': {
              'TITULO': 'Elige idioma principal.',
              'ACCION': '¿Cuál es el idioma principal de la encuesta?',
              'PLACELISTA': 'Seleccione un idioma.',
              'BOTONES': {
                'BACK': 'Regresar',
                'OK': 'Listo'
              }
            }
          },
          'CARD2': {
            'TITULO': 'Idiomas adicionales.',
            'ACCION': {
              'PRE': 'No ha seleccionado idiomas adicionales.',
              'SINADIC': 'La encuesta no tendrá idiomas adicionales.',
              'POST': 'Ha seleccionado los idiomas:'
            },
            'MODAL': {
              'TITULO': 'Elige idiomas adicionales',
              'ACCION': '¿Qué idiomas adicionales desea agregar a la encuesta?',
              'BOTONES': {
                'BACK': 'Regresar',
                'OK': 'Listo'
              }
            }
          }
        },
        'DEMOGRAFICOS': {
          'TAB1': 'Demográficos',
          'TAB2': 'Traducción',
          'TAB3': 'Previsualización',
          'COMPLETAR_PASO': 'Completar paso',
          'PASO_COMPLETADO': 'Paso completado',
          'SELECT': 'Seleccione una opción.',
          'BTN_DEMOGRAFICOS': 'Aceptar',
          'OPTION_SURVEY': 'Encuesta',
          'OPTION_EXCEL': 'Excel',
          'CONFIGURE_QUESTION': 'Presione aquí para configurar la pregunta',
          'QUESTION': 'Pregunta',
          'OPCIONES_RESPUESTA': 'Opciones de respuesta',
          'STATUS': {
            'PEND': 'Completar paso',
            'DONE': 'Paso completado'
          }
        },
        'FORALL': {
          'SELECCIONE': 'Seleccione un idioma para hacer una vista previa.',
          'IDIOMAS_NOT_SELECTED': 'No se seleccionaron idiomas adicionales.',
          'PLACEHOLDER': 'Idioma',
          'DESC_TRANSLATE': 'Ingrese la traducción de la descripción:',
          'PRACTICE_TRANSLATE': 'Ingrese la traducción de la práctica:',
          'MJS_SELECTOPTION': 'Seleccione una opción',
          'MJS_OPTIONADDED': 'Demográfico agregado correctamente.',
          'DEMOGRAPHICEXIST': 'El demográfico seleccionado ya existe.',
          'OPTIONDELETED': 'Demográfico eliminado correctamente.',
          'AGREGADEMOGRAFICO': 'Seleccione para agregar más demográficos.',

          'IDIOMAS': {
              'Native': 'Nativo',
              'es': 'Español',
              'zh1': 'Chino tradicional',
              'zh2': 'Chino simplificado',
              'pt': 'Portugués',
              'en': 'Inglés',
              'vi': 'Vietnamita'
            },
          'RESPUESTAS': {
              'Native': 'Nativo',
              'es':{'si': 'SÍ',
                    'no':'NO',
                    'casifalso':'Casi siempre es falso.',
                    'false': 'Frecuentemente es falso.',
                    'avecesfalse': 'A veces es falso. / A veces es verdad.',
                    'casiverdad': 'Frecuentemente es verdad.',
                    'verdad': 'Casi siempre es verdad.'},
              'zh1':{'si': '对','no':'没有',
                    'casifalso':'卡西尔·辛普森·法斯特',
                    'false': '基金会',
                    'avecesfalse': '途径/途径',
                    'casiverdad': '纪念馆',
                    'verdad': '普通绿卡'},
              'zh2':{'si': '对','no':'没有',
                    'casifalso':'卡西尔·辛普森·法斯特',
                    'false': '基金会',
                    'avecesfalse': '途径/途径',
                    'casiverdad': '纪念馆',
                    'verdad': '普通绿卡'},
              'pt':{'sí': 'Sí','no':'não',
                    'casifalso':'Casi siempre es falso.',
                    'false': 'Freqüentemente é falso.',
                    'avecesfalse': 'A veces es falso. / A veces es verdad.',
                    'casiverdad': 'Freqüentemente es verdad.',
                    'verdad': 'Casi siempre es verdad.'},
              'en':{'si': 'YES','no':'NO',
                    'casifalso':'It is almost always false',
                    'false': 'It is often false',
                    'avecesfalse': 'Sometimes it´s fake / Sometimes it´s true',
                    'casiverdad': 'It is often true',
                    'verdad': 'It is almost always true'}
            },
          'STATUS': {
            'PEND': 'Completar paso',
            'DONE': 'Paso completado'
          },
          'TABLA': {
            'TITULOS': {
              'DEFAULT': 'Idioma principal.',
              'TRADUCCION': 'Traducciones.',
              'PREVIEW': 'Previsualización.'
            },
            'ENCABEZADOS': {
              'PRACT': 'Práctica:',
              'DESCR': 'Descripción:',
              'STT1': 'Statement 1:',
              'STT2': 'Statement 2:',
              'LANG': 'Idioma'
            },
            'INPUTS': {
              'PRACT': 'Introduzca el texto de la práctica',
              'DESCR': 'Introduzca el texto de la descripción'
            }
          }
        },
        'ADICIONALES': {
          'STATUS': {
            'PEND': 'Completar paso',
            'DONE': 'Paso completado'
          },
          'TABS': {
            'QUESTIONS': 'Preguntas adicionales.',
            'TRANSLATE': 'Traducciones.',
            'PREVIEW': 'Previsualización.'
          },
          'PREGUNTAS':{
            'STATUS': {
              'SIN': 'No ha creado preguntas adicionales.',
              'CON': 'Preguntas creadas.',
              'NOADICIONALES': 'Se eligió la opción sin preguntas adicionales.',
              'CANCELNOADIC': 'Se canceló la opción sin preguntas adicionales.',
              'ERROR': 'Ocurrió un error al realizar la operación.'
            },
            'ACCIONES': {
              'ADD': 'Crear una pregunta',
              'SIN': 'No agregar preguntas adicionales a la encuesta'
            },
            'WIZARD': {
              'NEW': 'Nueva pregunta:',
              'TIPOTITU': 'Presione aquí para configurar la pregunta adicional',
              'TIPO': {
                'OPEN': 'Pregunta abierta:',
                'UNI': 'Pregunta de una opción:',
                'MULT': 'Pregunta de opción múltiple:'
              },
              'FORM': {
                'TIPO': 'Tipo de pregunta:',
                'TOOLTIP': {
                  'REMOVE': 'Remover esta pregunta'
                },
                'MENSAJES': {
                  'BORRAR': '¿Desea borrar esta pregunta adicional?',
                  'PREG_OK': 'La pregunta se almacenó correctamente',
                  'PREG_ERR': 'Ocurrió un error al almacenar la pregunta',
                  'PREG_MOD_OK': 'La pregunta se modificó correctamente',
                  'PREG_MOD_ERR': 'Ocurrió un error al modificar la pregunta',
                  'OPC_OK': 'La opción de respuesta se almacenó correctamente',
                  'OPC_ERR': 'Ocurrió un error al almacenar la opción de respuesta',
                  'OPC_MOD_OK': 'La opción de respuesta se modificó correctamente',
                  'OPC_MOD_ERR': 'Ocurrió un error al modificar la opción de respuesta',
                  'PREG_DEL_OK': 'La pregunta se eliminó correctamente',
                  'PREG_DEL_ERR': 'Ocurrió un error al eliminar la pregunta',
                  'OPC_DEL_OK': 'La opción de respuesta fue eliminada correctamente',
                  'OPC_DEL_ERR': 'Ocurrió un error al eliminar la opción de respuesta'
                },
                'BOTONES':{
                  'SI': 'Sí',
                  'NO': 'No'
                }
              },
              'ABIERTA': {
                'TITULO': 'Nueva pregunta abierta:',
                'ACCION': 'Introduzca el texto de la pregunta',
                'ERROR': 'No ha introducido el texto de la pregunta'
              },
              'MULTI':{
                'TITULOSING': 'Nueva pregunta de una opción:',
                'TITULOMULT': 'Nueva pregunta de opción múltiple:',
                'ACCION': 'Introduzca el texto de la pregunta',
                'ERROR': 'No ha introducido el texto de la pregunta',
                'MENSAJES': {
                  'BORRAR': '¿Desea borrar esta opción de respuesta?',
                  'SINPREG': 'No puede introducir opciones hasta que introduzca el texto de la pregunta',
                  'SINANTE': 'No puede introducir el texto de esta opción hasta que introduzca el texto de la opción anterior.'
                },
                'OPCIONES': {
                  'TITU': 'Opciones de respuesta:',
                  'INPUT': {
                    'TITU': 'Opción de respuesta:',
                    'ERROR': 'No ha introducido el texto de la opción de respuesta.'
                  }
                },
                'TOOLTIP': {
                  'ADD': 'Agregar una opción de respuesta.',
                  'MOVE': 'Mover opción de respuesta.',
                  'REMOVE': 'Remover esta opción de respuesta.'
                }
              }
            }
          },
          'TRADUCCIONES': {
            'TITULO': 'Seleccione un idioma para introducir los textos de traducción.',
            'TITULOALTERNO': 'No seleccionó idiomas adicionales en la sección "Idiomas".',
            'NOTYET': 'Traducción aún no completada.',
            'MAIN': 'Idioma principal',
            'INPUT': {
              'NEW': 'Introduzca la traducción de la pregunta',
              'ERROR': '¡No ha introducido el texto de traducción!',
              'NEWOPC': 'Introduzca la traducción de la opción de respuesta.',
              'ERROROPC': '¡No ha introducido el texto de traducción!'
            },
            'MENSAJES': {
              'PREG_OK': 'El texto de traducción se almacenó correctamente.',
              'PREG_ERR': 'Ocurrió un error al almacenar el texto de traducción.',
              'PREG_MOD_OK': 'El texto de traducción se actualizó correctamente.',
              'PREG_MOD_ERR': 'Ocurrió un error al actualizar el texto de traducción.',
              'OPC_NOPREG': 'No se puede almacenar el texto de traducción de la opción de respuesta sin que introduzca primero el texto de la pregunta',
              'OPC_OK': 'El texto de traducción se almacenó correctamente.',
              'OPC_ERR': 'Ocurrió un error al almacenar el texto de traducción.',
              'OPC_MOD_OK': 'El texto de traducción se actualizó correctamente.',
              'OPC_MOD_ERR': 'Ocurrió un error al actualizar el texto de traducción.'
            },
            'COMPLETE': 'Traducción completa.'
          },
          'PREVIEW': {
            'TITULO': 'Seleccione un idioma para mostrar las traducciones de las preguntas adicionales.',
            'SINPREV': 'No existen textos traducidos para el idioma seleccionado.',
            'LOADING': 'Cargando datos...',
            'INPUT': {
              'RESPABIERTA': 'Escriba su respuesta:',
              'ERRORABIERTA': '¡No ha escrito su respuesta!',
              'ELIGELANG': 'Elija un idioma'
            },
            'HELP': {
              'SINGLE': 'Puede elegir una sola opción en esta pregunta',
              'MULTI': 'Puede elegir más de una opción en esta pregunta'
            }
          }
        },
        'COLABORADORES': {
          'TITULO':'Descargar la hoja de centros de trabajo',
          'TITULOCT':'Lista de centro de trabajos',
          'SHEET':{
            'NUMBER':'Nombre de hoja'
          },
          'STATUS': {
            'PEND': 'Completar paso',
            'DONE': 'Paso completado',
            'LOCK':'Reabrir paso',
          },
          'STATUSBAR': {
            'NOBD': 'No ha cargado la lista de colaboradores',
            'PROCES': 'La lista de colaboradores aún no ha sido almacenada',
            'ERROR': 'Se encontraron errores en el archivo.',
            'OK': 'La lista de colaboradores está almacenada correctamente'
          },
          'CARD_BD': {
            'TITULO': 'Información: ',
            'NUMCOLABS': 'Número de colaboradores: ',
            'NUMCENTER': 'Número de centros de trabajo: ',
            'FECHA': 'Fecha de carga: ',
            'ACCIONES': 'Acciones: ',
            'WANNADO': '¿Qué desea realizar?',
            'BOTONES': {
              'DESCARGA': 'Descargar la lista de colaboradores',
              'ELIMINA': 'Eliminar la lista'
            }
          },
          'CARD_NOBD': {
            'TITULO': 'Siga estos pasos para cargar la información de sus colaboradores a CULTURAL GO®',
            'PASOS': {
              '1': 'Descargue la plantilla de la lista de colaboradores',
              '2': 'Llene la plantilla con la información de sus colaboradores, en base a las columnas proporcionadas',
              '3': 'Cargue el archivo con la información de sus colaboradores'
            },
            'TOOLTIP': 'Este archivo cuenta con macros de validación de datos'
          },
          'CARD_NOERR': {
            'TITULO': 'Información: ',
            'NUMCOLABS': 'Número de colaboradores en el archivo: ',
            'NUMCT': 'Número de centros de trabajo en el archivo: ',
            'FILENAME': 'Nombre del archivo: ',
            'GUARDAR': '¿Desea almacenar esta información?',
            'BOTONES': {
              'SI': 'Sí',
              'NO': 'No'
            }
          },
          'CARD_ERRFND': {
            'TITULO': 'Información: ',
            'ROWS_OK': 'Número de filas correctas: ',
            'ROWS_NOTOK': 'Número de filas con errores: ',
            'MOREINFO': '* Más abajo se muestra a detalle la lista de errores.',
            'FILENAME': 'Nombre del archivo: ',
            'GUARDAR': 'La información cargada no puede ser almacenada',
            'DELETE': 'Borrar archivo'
          },
          'CARD_ERRLIST': {
            'TITULO': {
              '1': 'Filas con errores: ',
              '2': 'Errores totales encontrados: ',
              '3': 'Datos de los colaboradores '
            },
            'INFO': {
              'ROW': 'Fila: ',
              'ERRNUM': 'Número de errores: ',
              'SHOW': 'Presione aquí para ver los errores de esta fila'
            },
            'DETALLE': {
              'TIPO': 'Tipo de error: ',
              'DESCR': 'Descripción: ',
              'COLUMNA': 'Columna: ',
              'DATO': 'Dato erróneo: '
            },
            'ERRORES': {
              'alfabetica': 'Invalidez alfabética',
              'alfanumerica': 'Invalidez alfanumérica',
              'numerica': 'Invalidez numérica',
              'email': 'Invalidez de correo electrónico',
              'date': 'Invalidez de fecha de ingreso',
              'vacio': 'Celda vacía',
              'columna': 'Columna desconocida',
              'CT': 'Centro de trabajo no encontrado',
              'catSurvey': 'Data desconocida',
              'repetido': 'Clave colaborador repetido',
              'repetidoMail': 'Correo electrónico repetido',
              'clavenumerica':'Invalidez de clave',
            },
            'DESCRIPCION': {
              'alfabetica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres alfabéticos (A - Z) y los siguientes caracteres especiales: ( ) . , : - ',
              'alfanumerica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres alfabéticos (A - Z), numéricos (0 - 9) y los siguientes caracteres especiales: ( ) . , : - ',
              'numerica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres numéricos (0 - 9)',
              'email': 'La información no cuenta con la sintáxis correcta ( correo@dominio.com )',
              'vacio': 'La celda carece de información. Esta columna es obligatoria.',
              'columna': 'La columna no pertenece a la plantilla proporcionada por CulturalGO',
              'CT': 'El centro de trabajo especificado en esta fila no se encontró en la lista de centros de trabajo disponibles',
              'catSurvey': 'La información no es correcto con el catálogo requerido',
              'repetido': 'El campo esta repetido en una o más filas',
              'repetidoMail': 'Se ha encontrado más de una vez el mismo correo electronico',
              'clavenumerica':'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres alfabéticos (A - Z), numéricos (0 - 9) y el siguiente caracter especial: - ',
              'date': 'La información introducida no cuenta con el formato correcto de fecha',
            }
          },
          'CARD_LOAD': {
            'CARGA': {
              'TITULO': 'Cargando...',
              'INFO': 'Analizando la información del archivo, espere un momento...'
            },
            'GUARDA': {
              'TITULO': 'Guardando...',
              'INFO': 'Almacenando la información en el sistema, permanezca en esta pantalla hasta que el proceso finalice.'
            },
          },
          'MENSAJES': {
            'GUARDA_1': '¿Confirme almacenar la información de ',
            'GUARDA_2': ' colaboradores y centros de trabajo respectivamente?',
            'GUARDADO': 'La lista de colaboradores se almacenó correctamente',
            'GUA_ERR': 'Ocurrió un error al almacenar la información. Intente nuevamente más tarde.',
            'DELETE_1': '¿Confirme eliminar la información de ',
            'DELETE_2': ' colaboradores y centros de trabajo respectivamente?',
            'DEL_OK_1': 'Se eliminaron correctamente ',
            'DEL_OK_2': ' los datos de la lista.',
            'DEL_ERR': 'Ocurrió un error al eliminar la lista de colaboradores. Intente nuevamente más tarde.',
            'DELFILE': 'La lista cargada se removió correctamente.',
            'EXCEL': 'Generando archivo de excel, por favor espere un momento.',
            'EXTMAL': 'El archivo seleccionado no tiene la extensión correcta. Sólo se permite la carga del archivo proporcionado por CULTURAL GO®.',
            'NOROWS': 'El archivo seleccionado no cuenta con ningún registro.',
            'VACIO': 'El archivo seleccionado está vacío, o la información no se encuentra en la primer hoja',
            'BOTONES': {
              'SI': 'Sí',
              'NO': 'No'
            }
          },
          'EXCELINFO': {
            'HOJA': 'Datos de colaboradores.',
            'TITULO': 'Lista de colaboradores:',
            'AUTOR': 'CULTURAL GO®.',
            'ASUNTO': 'Descargado de la plataforma'
          },
          'UPLOAD': 'Presione aquí para buscar la lista de colaboradores.',
          'REMOVE': 'Remover de la carga',
          'SEND': 'Enviar a la lista',
          'PROCESO': {
            'STP1': 'Analizando la lista de colaboradores.',
            'STP2': 'Guardando la lista de colaboradores.'
          }
        }
      },
      'PDF':{
        'TITLE':'Catálogo de evidencias para la norma NOM-035-STPS-2018',
        'IND':'Índice',
        'MAIN1':'I. Objetivo',
        'MAIN2':'II. Alcance',
        'MAIN3':'III. Evidencias',
        'INCISOA':'a) Evidencias documentales de la política de prevención de riesgos psicosociales',
        'INCISOB':'b) Información del cuestionario aplicado',
        'INCISOC':'c) Información de las medidas de prevención de los factores de riesgo psicosocial',
        'INCISOD':'d) Información de las medidas de control adoptadas en el centro de trabajo',
        'INCISOE':'e) Información de las acciones adoptadas para identificar a los trabajadores',
        'INCISOF':'f) Información de la atención brindada a los trabajadores expuestos',
        'INCISOG':'g) Registros de las acciones realizadas en los trabajadores',
        'PARRAFO1':'Entregar en un solo documento los enlaces de acceso a las evidencias solicitadas en el punto 10 “procedimiento para la evaluación de la conformidad” de la NOM-035-STPS-2018',
        'PARRAFO2':'Este documento recopila las evidencias que se agregan en la plataforma CGO de acuerdo al punto 10 de la NOM-035-STPS-2018.',
        'SECCION1':'Sección de CGO',
        'SECCION2':'Observaciones',
        'SECCION3':'Enlace',
        'BTN':'Crear PDF'

      },
      'TIMELINE':{
        'ETAPA1':{
          'SECCION1':{
            'actividad': "Generar política de prevención de riesgos psicosociales contemplando prevención de los factores de riesgo psicosocial y de la violencia laboral, promoción de un entorno organizacional favorable.",
            'entregable': "Política.",

          },
          'SECCION2':{
            'actividad':"Generar proceso de encuesta y definir registros de realización de encuesta.",
            'entregable': "Flujo de proceso.",
          },
          'SECCION3':{
            'actividad': "Generar proceso de encuesta y definir registros de realización de encuesta.",
            'entregable': "Flujo de proceso.",

          },
          'SECCION4':{
            'actividad': "Generar plan de desarrollo organizacional fomentando la cultura de la prevención y el fomento del entorno organizacional favorable.",
            'entregable': "Campaña 'Fomento de la NOM-035', cronograma de implementación y actividades a realizar.",

          },
          'SECCION5':{
            'actividad': "Campaña de difusión sobre las políticas de prevención de riesgos psicosociales, medidas adoptadas, de prevención posibles riesgos de trabajo y el mecanismo para denuncias.",
            'entregable': "Campaña 'Fomento de la NOM-035', cronograma de implementación y actividades a realizar.",

          },
          'SECCION6':{
            'actividad': "Uso de CGO para el repositorio de registros y seguimiento a trabajadores.",
            'entregable': "Expedientes del trabajador.",
          },
          'SECCION7':{
            'actividad': "Integrar en los perfiles de puesto los riesgos de condiciones en el ambiente de trabajo.",
            'entregable': "Perfil de puesto.",
          },
          'SECCION8':{
            'actividad': "Integrar en los perfiles de puesto los riesgos de condiciones en el ambiente de trabajo.",
            'entregable': "Perfil de puesto.",
          },
          'SECCION9':{
            'actividad': "Integrar en los perfiles de puesto los riesgos de condiciones en el ambiente de trabajo.",
            'entregable': "Perfil de puesto.",
          },
          'SECCION10':{
            'actividad': "Proceso de línea de denuncias con la definición de liderazgo negativo y relaciones negativas de trabajo.",
            'entregable': "Flujo de proceso.",
          },
          'SECCION11':{
            'actividad': "Proceso de evaluación del entorno organizacional favorable.",
            'entregable': "Flujo de proceso.",
          },
          'SECCION12':{
            'actividad': "Integración de cultura GPTW en el personal.",
            'entregable': "Campaña 'Fomento de la NOM-035', cronograma de implementación y actividades a realizar.",
          },
          'SECCION13':{
            'actividad': "Perfiles de puesto con análisis de riesgos en el área de trabajo.",
            'entregable': "Perfil de puesto.",
          },
          'SECCION14':{
            'actividad': "Perfiles de puesto con análisis de riesgos en el área de trabajo.",
            'entregable': "Perfil de puesto.",
          },
          'SECCION15':{
            'actividad': "Generar proceso de recorrido de seguridad e higiene y su reporte.",
            'entregable': "Flujo de proceso.",

          },
          'SECCION16':{
            'actividad': "Proceso de encuesta NOM-035.",
            'entregable': "Flujo de proceso.",

          },
          'SECCION17':{
            'actividad': "Campaña de difusión sobre las políticas de prevención de riesgos psicosociales, medidas adoptadas, de prevención posibles riesgos de trabajo y el mecanismo para denuncias.",
            'entregable': "Campaña 'Fomento de la NOM-035', cronograma de implementación y actividades a realizar.",

          },
          'SECCION18':{
            'actividad': "Proceso de línea de denuncias.",
            'entregable': "Flujo de proceso.",
          },
          'SECCION19':{
            'actividad': "Acciones y programas para la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral.",
            'entregable': "Campaña 'Fomento de la NOM-035', cronograma de implementación y actividades a realizar.",
          }

        },
        'ETAPA2':{
          'SECCION1':{
            'actividad': "Generar proceso para la canalización de trabajadores con acontecimientos traumáticos severos y que se identificaron en la encuesta.",
            'entregable': "Flujo de proceso.",

          },
          'SECCION2':{
            'actividad'  : "Generar proceso para la canalización de trabajadores con acontecimientos traumáticos severos y que se identificaron en la encuesta.",
            'entregable': "Flujo de proceso.",

          },
          'SECCION3':{
            'actividad'  : "Proceso para comunicación de resultados.",
            'entregable': "Flujo de proceso.",

          },
          'SECCION4':{
            'actividad'  : "Generar proceso de encuesta y definir registros de realización de encuesta.",
            'entregable': "Flujo de proceso.",

          },
          'SECCION5':{
            'actividad'  : "Plan de capacitación anual y ligar acciones correctivas y de mejora continua.",
            'entregable': "Plan de capacitación anual, flujo de proceso de acciones correctivas.",

          },
          'SECCION6':{
            'actividad'  : "Política de comunicación interna.",
            'entregable': "Política.",

          },
          'SECCION7':{
            'actividad'  : "Política de comunicación interna.",
            'entregable': "Política.",

          },
          'SECCION8':{
            'actividad'  : "Plan de capacitación.",
            'entregable': "Plan de capacitación anual.",

          },
          'SECCION9':{
            'actividad'  : "Política de comunicación interna.",
            'entregable': "Política.",

          },
          'SECCION10':{
            'actividad'  : "Sistemas de reconocimiento.",
            'entregable': "Política y mecanismos de reconocimiento.",

          },
          'SECCION11':{
            'actividad'  : "Proceso de encuesta NOM-035.",
            'entregable': "Flujo de proceso.",

          },
          'SECCION12':{
            'actividad'  : "No aplica por que se usa la encuesta de la norma.",
            'entregable': "N/A.",

          },
          'SECCION13':{
            'actividad'  : "Perfiles de puesto con análisis de riesgos en el área de trabajo.",
            'entregable': "Perfil de puesto.",

          },
          'SECCION14':{
            'actividad'  : "Perfiles de puesto con análisis de riesgos en el área de trabajo.",
            'entregable': "Perfil de puesto.",

          },
          'SECCION15':{
            'actividad'  : "Lo genera la plataforma CGO.",
            'entregable': "Reporte.",

          },
          'SECCION16':{
            'actividad'  : "Comunicar los resultados de la evaluación del riesgo psicosocial.",
            'entregable': "Flujo de proceso y política.",

          },
          'SECCION17':{
            'actividad'  : "Plan de desarrollo organizacional para mejora de la comunicación, sentido de pertenencia, participación en mejora continua, la evaluación y reconocimiento del desempeño.",
            'entregable': "Plan de desarrollo organizacional.",

          },
          'SECCION18':{
            'actividad'  : "DNC cada dos años.",
            'entregable': "Flujo de proceso, reporte de DNC.",
          },
          'SECCION19':{
            'actividad'  : "Plan de capacitación anual y ligar acciones correctivas y de mejora continua.",
            'entregable': "Plan de capacitación, flujo de proceso.",
          },
          'SECCION20':{
            'actividad':"Proceso de acciones correctivas y su adecuación para la NOM-035.",
            'entregable':"Flujo de proceso.",
          }
        }
      }
    }
};
